import dmi from './utils/deep-merge-inmutable';
import base from './base';
export default dmi(base, {
    message: {
        userActive: {
            profile_employee_tooltip: "Perfil diseñado para empleados con permisos para ver, descargar y firmar sus Payslip de sueldo. Solo se podrá seleccionar uno por usuario.",
            profile_management_tooltip: "Perfiles diseñados para el personal de recursos humanos. Permite gestionar datos de usuarios, notificaciones y Payslip de sueldo. Solo se podrá seleccionar uno por usuario.",
            profile_limited_access_tooltip: "Perfil diseñado para el personal de recursos humanos con acceso limitado. Permite gestionar datos de usuarios, notificaciones y Payslip de sueldo. Solo se podrá seleccionar uno por usuario. Al seleccionar este perfil, podrá configurar filtros por sector y/o locación a continuación.",
            cuil: "Registration Number",
            cuils: "Registration Numbers",
        },
        label: {
            dni: "DNI",
        },
        head_text_table_search_3: "Registration Number",
        search_text_1_1: "Registration Number, Nombre, Apellido o Email",
        uploadImageComponent: {
            body: {
                leftContainer: {
                    filter: {
                        inputPlaceholder: "Nombre, apellido, Registration Number, fecha, sector y locación",
                        inputBaseMessage: "Buscar por Nombre, Apellido, Registration Number",
                        cuil: "Registration Number",
                    }
                }
            }
        },
        publishDocuments: {
            configIndivualPublish: {
                inputCuil: {
                    label: "Indentificador",
                    question: "¿Cuál es el Indentificador del colaborador?",
                    description: "Ingresa el Indentificador del colaborador al que quieres enviarle un documento"
                },
            }
        },
        certificates: {
            newCertificate: {
                personalInfo: {
                    dni: "Documento",
                },
                dni: "Documento"
            }
        },
        documentDetail: {
            commons: {
                cuil: "Registration Number",
            }
        }
    }
})